import EscapeScreenLayout from "@/components/EscapeScreenLayout";
import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import { Button } from "@/components/ui/button";
import { t } from "i18next";
import { RefreshCw } from "lucide-react";

type ServiceErrorPageProps = {
    withLogout?: boolean;
};

const ServiceErrorPage = ({ withLogout = true }: ServiceErrorPageProps) => {
    const handleReload = () => {
        window.location.reload();
    };

    return (
        <EscapeScreenLayout>
            <div className="flex max-w-md flex-col items-center text-center">
                <h1 className="mb-4 font-display text-2xl font-bold leading-snug text-text-mainTitle md:text-3xl">
                    {t("serviceError.title")}
                </h1>

                <p className="mb-8 max-w-sm text-base leading-relaxed text-text-body">
                    {t("serviceError.description")}
                </p>

                <div className="flex w-full max-w-xs flex-col gap-3">
                    <Button
                        className="w-full"
                        icon={<RefreshCw className="h-4 w-4" />}
                        onClick={handleReload}
                        size="lg"
                        variant="purpleGradient"
                    >
                        {t("serviceError.retry")}
                    </Button>

                    {withLogout && <LogoutEscapeLink variant="outline" />}
                </div>

                <p className="mt-8 max-w-xs text-sm leading-relaxed text-text-caption">
                    {t("serviceError.hint")}
                </p>
            </div>
        </EscapeScreenLayout>
    );
};

export default ServiceErrorPage;
